import React from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

const statusOptions = [
    { value: "new", label: "New" },
    { value: "accepted", label: "Accepted" },
    { value: "followup", label: "In Followup" },
    { value: "denied-pending", label: "Denied (Pending)" },
    { value: "denied-approved", label: "Denied (Approved)" },
    { value: "denied-rejected", label: "Denied (Rejected)" },
    { value: "completed", label: "Completed" },
    { value: "re-complaint", label: "Re-Complaint" }
];

const StatusDropdown = ({ current }) => {
    const navigate = useNavigate();

    const handleChange = (selected) => {
        navigate(`/admin/crm/vendor-call/${selected.value}`);
    };

    return (
        <>

         <Select
            options={statusOptions}
            value={statusOptions.find(o => o.value === current)}
            onChange={handleChange}
            placeholder="Choose Status..."
        />

        
        </>
       
    );
};

export default StatusDropdown;
export { statusOptions };
